module.exports = "../../../../platform/assets/pageMainIcon/industry_yewuchulilei2.svg";